import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import Box from '@material-ui/core/Box';
import CircularProgress from '@material-ui/core/CircularProgress';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import Typography from '@material-ui/core/Typography';
import strings from 'strings';
import { FPActionButton, TextBox, When } from 'UI/components/atoms';

import { ReasonsCheckboxGroup } from './ReasonsCheckboxGroup';
import { VerticalStack } from './ReasonsSelector.styled';

const { declinationReasons: STRINGS } = strings.sendoutsV2.form.sections;

export const ReasonsSelector = ({
  commentsFieldName = 'comments',
  commentsLabel = STRINGS.commentsLabel,
  commentsPlaceholder = STRINGS.commentsLabel,
  hasReasonsError = false,
  isLoadingReasons = false,
  onRetryReasons,
  reasons = [],
  reasonsErrorMessage = STRINGS.catalogUnavailable,
  reasonsFieldName = 'reasons',
  reasonsValidationMessage = STRINGS.reasonsValidationMessage,
  required = true,
  subtitle = STRINGS.subtitle
}) => {
  const { control, errors, register } = useFormContext();

  const hasError = Boolean(errors[reasonsFieldName]);
  const showReasons = !isLoadingReasons && !hasReasonsError;

  return (
    <VerticalStack>
      <Typography variant="body2">{subtitle}</Typography>

      <FormControl component="fieldset" error={hasError}>
        <When condition={isLoadingReasons}>
          <CircularProgress size={24} />
        </When>

        <When condition={hasReasonsError}>
          <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center">
            <Typography color="error" variant="body2">
              {reasonsErrorMessage}
            </Typography>
            <When condition={!!onRetryReasons}>
              <FPActionButton
                onClick={onRetryReasons}
                text={strings.shared.ui.retry}
                variant="outlined"
              />
            </When>
          </Box>
        </When>

        <When condition={showReasons}>
          <Controller
            as={<ReasonsCheckboxGroup reasons={reasons} />}
            control={control}
            defaultValue={[]}
            name={reasonsFieldName}
            rules={{
              validate: value =>
                !required || (Array.isArray(value) && value.length > 0) || reasonsValidationMessage
            }}
          />
        </When>

        <When condition={hasError}>
          <FormHelperText>{errors[reasonsFieldName]?.message}</FormHelperText>
        </When>
      </FormControl>

      <When condition={showReasons}>
        <TextBox
          inputRef={register()}
          label={commentsLabel}
          multiline
          name={commentsFieldName}
          placeholder={commentsPlaceholder}
        />
      </When>
    </VerticalStack>
  );
};
